var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"top",class:{ dark: this.color },style:(_vm.customStyle),attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('spinner',{attrs:{"loading":_vm.tf}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }